import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const committeeMemberRolesApi = {
    getCommitteeMemberRoles: (committeeId: number, committeeMemberId: number): Observable<Dtos.GetCommitteeMemberRolesResponse> => {
        //Create the request.
        let request: Dtos.GetCommitteeMemberRoles = new Dtos.GetCommitteeMemberRoles();

        request.committeeId = committeeId;
        request.committeeMemberId = committeeMemberId;

        //Send request.
        const response: Promise<Dtos.GetCommitteeMemberRolesResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getCommitteeMemberRoleById: (id: number): Observable<Dtos.GetCommitteeMemberRoleByIdResponse> => {
        //Create the request.
        let request: Dtos.GetCommitteeMemberRoleById = new Dtos.GetCommitteeMemberRoleById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetCommitteeMemberRoleByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getCommitteeMemberRoleByCommitteeId: (committeeId: number, committeeMemberId: number): Observable<Dtos.GetCommitteeMemberRoleByCommitteeIdResponse> => {
        //Create the request.
        let request: Dtos.GetCommitteeMemberRoleByCommitteeId = new Dtos.GetCommitteeMemberRoleByCommitteeId();

        request.committeeId = committeeId;
        request.committeeMemberId = committeeMemberId;

        //Send request.
        const response: Promise<Dtos.GetCommitteeMemberRoleByCommitteeIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getCommitteeMemberRolesByPersonnelId: (personnelId: number): Observable<Dtos.GetCommitteeMemberRolesByPersonnelIdResponse> => {
        //Create the request.
        let request: Dtos.GetCommitteeMemberRolesByPersonnelId = new Dtos.GetCommitteeMemberRolesByPersonnelId();

        request.personnelId = personnelId;

        //Send request.
        const response: Promise<Dtos.GetCommitteeMemberRolesByPersonnelIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setCommitteeMemberRole: (committeeMemberRole: Dtos.CommitteeMemberRole): Observable<Dtos.SetCommitteeMemberRoleResponse> => {

        let request: Dtos.SetCommitteeMemberRole = new Dtos.SetCommitteeMemberRole();

        request.committeeMemberRole = committeeMemberRole;

        // send request
        const response: Promise<Dtos.SetCommitteeMemberRoleResponse> = client.post(request);

        return Observable.from(response);
    },
    createCommitteeMemberRole: (committeeId: number, committeeMemberId: number): Observable<Dtos.CreateCommitteeMemberRoleResponse> => {
        //Create the request.
        let request: Dtos.CreateCommitteeMemberRole = new Dtos.CreateCommitteeMemberRole();

        request.committeeId = committeeId;
        request.committeeMemberId = committeeMemberId;

        //Send request.
        const response: Promise<Dtos.CreateCommitteeMemberRoleResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateCommitteeMemberRole: (committeeMemberRole: Dtos.CommitteeMemberRole): Observable<Dtos.ValidateCommitteeMemberRoleResponse> => {

        let request: Dtos.ValidateCommitteeMemberRole = new Dtos.ValidateCommitteeMemberRole();

        request.committeeMemberRole = committeeMemberRole;

        // send request
        const response: Promise<Dtos.ValidateCommitteeMemberRoleResponse> = client.post(request);

        return Observable.from(response);
    },
}